import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=8e6427ca&scoped=true&"
import script from "./CourseList.vue?vue&type=script&lang=ts&"
export * from "./CourseList.vue?vue&type=script&lang=ts&"
import style0 from "./CourseList.vue?vue&type=style&index=0&id=8e6427ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6427ca",
  null
  
)

export default component.exports